// src/pages/Appli/AppliAdmin/ListingClients/ui/InlineStatutSelect.jsx

import React, { useMemo } from "react";

import {
  FaChevronDown,
  FaSpinner,
} from "react-icons/fa";

import {
  ASSOCIATION_STATUS_VALUES,
  getAssociationStatusMeta,
} from "../data/associations.data";

export function InlineStatutSelect({
  value = "",
  onChange,
  options = ASSOCIATION_STATUS_VALUES,
  size = "md",
  disabled = false,
  updating = false,
  label = "Modifier le statut",
  className = "",
}) {
  const meta = getAssociationStatusMeta(value);

  const availableOptions = useMemo(() => {
    if (!value || options.includes(value)) {
      return options;
    }

    return [value, ...options];
  }, [options, value]);

  const sizeClass =
    size === "sm"
      ? "min-h-8 pl-2.5 pr-7 text-xs"
      : "min-h-9 pl-3 pr-8 text-sm";

  return (
    <div
      className={[
        "relative inline-flex max-w-full items-center",
        "rounded-xl ring-1 ring-inset",
        meta.tone,
        disabled || updating
          ? "cursor-not-allowed opacity-70"
          : "",
        className,
      ].join(" ")}
    >
      <select
        value={value}
        onChange={(event) =>
          onChange?.(event.target.value)
        }
        disabled={disabled || updating}
        aria-label={label}
        className={[
          "max-w-full appearance-none",
          "cursor-pointer bg-transparent",
          "font-medium outline-none",
          "disabled:cursor-not-allowed",
          sizeClass,
        ].join(" ")}
      >
        {availableOptions.map((option) => (
          <option
            key={option}
            value={option}
            className="bg-white text-slate-900"
          >
            {option}
          </option>
        ))}
      </select>

      <span className="pointer-events-none absolute right-2 flex items-center">
        {updating ? (
          <FaSpinner className="animate-spin text-xs" />
        ) : (
          <FaChevronDown className="text-[10px] opacity-70" />
        )}
      </span>
    </div>
  );
}

export default InlineStatutSelect;